import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, GiftIcon, SparklesIcon, TagIcon } from 'lucide-react';
const BOOKING_URL = 'https://appointments.4patientcare.app/?CoverKey=5118&Source=website%20WebSchedV4&ReferredBy=Unknon&Gcount=0';
export function SpecialOffersModal() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false);
  useEffect(() => {
    if (hasBeenDismissed) return;
    // Only show on desktop
    const isDesktop = window.innerWidth >= 768;
    if (!isDesktop) return;
    const handleScroll = () => {
      const heroSection = document.getElementById('home');
      if (heroSection) {
        const rect = heroSection.getBoundingClientRect();
        // Show when hero section is mostly out of view
        if (rect.bottom < 100 && !hasBeenDismissed) {
          setIsVisible(true);
        }
      } else {
        // Fallback if no hero section
        if (window.scrollY > 500 && !hasBeenDismissed) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Check initially in case they load scrolled down
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasBeenDismissed]);
  const handleClose = () => {
    setIsVisible(false);
    setHasBeenDismissed(true);
  };
  return <AnimatePresence data-id="element-692">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-6 right-6 z-[90] w-full max-w-sm hidden md:block" data-id="element-693">
          <div className="bg-white rounded-card shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-694">
            {/* Top accent bar */}
            <div className="h-1.5 w-full bg-brand-gold" data-id="element-695"></div>

            {/* Header */}
            <div className="p-4 pb-2 flex justify-between items-start" data-id="element-696">
              <div className="flex items-center gap-2" data-id="element-697">
                <div className="bg-brand-gold/10 p-1.5 rounded-full" data-id="element-698">
                  <TagIcon className="w-4 h-4 text-brand-gold" data-id="element-699" />
                </div>
                <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-700">
                  Special Offers
                </h3>
              </div>
              <button onClick={handleClose} className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors focus-ring" aria-label="Close offers" data-id="element-701">
                <XIcon className="w-4 h-4" data-id="element-702" />
              </button>
            </div>

            {/* Content */}
            <div className="p-4 pt-2 space-y-3" data-id="element-703">
              {/* Offer 1 */}
              <div className="flex gap-3 items-start p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-704">
                <GiftIcon className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-705" />
                <div data-id="element-706">
                  <h4 className="font-semibold text-sm text-brand-dark leading-tight mb-1" data-id="element-707">
                    1 Free Frame
                  </h4>
                  <p className="text-xs text-neutral-text/70" data-id="element-708">
                    With purchase of $99+ (Self-Pay patients only)
                  </p>
                </div>
              </div>

              {/* Offer 2 */}
              <div className="flex gap-3 items-start p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-709">
                <SparklesIcon className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-710" />
                <div data-id="element-711">
                  <h4 className="font-semibold text-sm text-brand-dark leading-tight mb-1" data-id="element-712">
                    Free Contact Lens Follow-Up
                  </h4>
                  <p className="text-xs text-neutral-text/70" data-id="element-713">
                    Complimentary follow-up visit included
                  </p>
                </div>
              </div>

              {/* CTA */}
              <div className="pt-2" data-id="element-714">
                <a href={BOOKING_URL} target="_blank" rel="noreferrer" onClick={handleClose} className="block w-full bg-brand-gold hover:bg-brand-gold-light text-white text-center py-2.5 rounded-button font-heading font-semibold text-sm transition-colors shadow-md focus-ring" data-id="element-715">
                  Get Offer & Book Now
                </a>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}